
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HyperLinkBody"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLink"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"text"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TiiFull"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Tii"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"link"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"company_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"product_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sell_start_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sell_end_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approved_date"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"approved_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contents"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HyperLinkBody"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"contracts"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HyperLinkBody"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"proposals"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HyperLinkBody"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"fees"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HyperLinkBody"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"appended_insurances"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HyperLinkBody"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"benefits"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HyperLinkBody"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"registers"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HyperLinkBody"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"last_modified"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ticket_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uploader"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":531}};
    doc.loc.source = {"body":"fragment HyperLinkBody on HyperLink {\n  text\n  link\n}\n\nfragment TiiFull on Tii {\n  _id\n  link\n  company_id\n  category_id\n  product_id\n  name\n  sell_start_date\n  sell_end_date\n  approved_date\n  approved_id\n  contents {\n    ...HyperLinkBody\n  }\n  contracts {\n    ...HyperLinkBody\n  }\n  proposals {\n    ...HyperLinkBody\n  }\n  fees {\n    ...HyperLinkBody\n  }\n  appended_insurances {\n    ...HyperLinkBody\n  }\n  benefits {\n    ...HyperLinkBody\n  }\n  registers {\n    ...HyperLinkBody\n  }\n  status\n  last_modified\n  ticket_id\n  uploader\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["HyperLinkBody"] = oneQuery(doc, "HyperLinkBody");
        
        module.exports["TiiFull"] = oneQuery(doc, "TiiFull");
        
